import { createFileRoute } from '@tanstack/react-router'
import { EmailTemplateEditor } from './-EmailTemplateEditor'

export const Route = createFileRoute('/settings/email-templates/$id')({
  component: EmailTemplateEditorPage,
})

function EmailTemplateEditorPage() {
  const { id } = Route.useParams()
  return <EmailTemplateEditor id={id} />
}
